import { Radio } from 'antd';
import './index.scss';

export default (props) => {
  const { options = [], value, label } = props;

  return (
    <div className="zorba-radio-group-container">
      {label && <label htmlFor="radio-group">{label}</label>}
      <Radio.Group
        id="radio-group"
        className="zorba-radio-group"
        direction="horizontal"
        onChange={(newVal) => props.onChange(newVal)}
        value={value}
      >
        {options.map((singleOption) => (
          <Radio.Button value={singleOption.value}>
            {singleOption.text}
          </Radio.Button>
        ))}
      </Radio.Group>
    </div>
  );
};
